import React from 'react';
import Sticky from 'react-stickynode';
import leafFlutteringInWind from 'assets/images/leaf-fluttering-in-wind.png';
import sneezingFace from 'assets/images/sneezing-face.png';
import baby from 'assets/images/baby.png';
import dogFace from 'assets/images/dog-face.png';
import construction from 'assets/images/construction.png';
import woman from 'assets/images/woman.png';
import explodingHead from 'assets/images/exploding-head.png';
import loadable from '@loadable/component';

const LazyImg = loadable(() => import('../common/LazyImg'));

/**
 * @param selectedItem
 * @param setSelectedItem
 * @param filterScrollTop
 * @param topOffset
 * @param bottomOfffset
 * @returns {JSX.Element}
 * @constructor
 */
const ReviewsFilter = ({
  selectedItem, setSelectedItem, filterScrollTop, topOffset, bottomOfffset,
}) => {
  const onClick = e => {
    e.preventDefault();
    const _this = e.currentTarget;
    const getFilterAttr = _this.getAttribute('data-filter');
    if (_this.classList.contains('filter-items__item--active')) {
      setSelectedItem(currentArr => currentArr.filter(arrItem => arrItem !== getFilterAttr));
    } else {
      setSelectedItem(currentArr => [ ...currentArr, getFilterAttr ]);
    }
    filterScrollTop();
  };

  return (
    <Sticky enabled top={topOffset} bottomBoundary={bottomOfffset}>
      <div className={`filter-items ${selectedItem.length ? 'filter-items--selected' : ''}`}>
        <button
          type='button'
          className={`filter-items__item filter-items__item--big-sneeze ${selectedItem.includes('big-sneeze') ? 'filter-items__item--active' : ''}`}
          data-filter='big-sneeze'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Big Sneeze</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={sneezingFace} alt='sneezing-face' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--critter-cuddler ${selectedItem.includes('critter-cuddler') ? 'filter-items__item--active' : ''}`}
          data-filter='critter-cuddler'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Critter Cuddler</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={dogFace} alt='dog-face' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--basic-breather ${selectedItem.includes('basic-breather') ? 'filter-items__item--active' : ''}`}
          data-filter='basic-breather'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Basic Breather</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={leafFlutteringInWind} alt='leaf-fluttering-in-wind' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--rookie-parent ${selectedItem.includes('rookie-parent') ? 'filter-items__item--active' : ''}`}
          data-filter='rookie-parent'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Rookie Parent</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={baby} alt='baby' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--home-wrecker ${selectedItem.includes('home-wrecker') ? 'filter-items__item--active' : ''}`}
          data-filter='home-wrecker'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Home Wrecker</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={construction} alt='construction' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--mama-to-be ${selectedItem.includes('mama-to-be') ? 'filter-items__item--active' : ''}`}
          data-filter='mama-to-be'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Mama-to-be</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={woman} alt='woman' />
          </figure>
        </button>
        <button
          type='button'
          className={`filter-items__item filter-items__item--overreactor ${selectedItem.includes('overreactor') ? 'filter-items__item--active' : ''}`}
          data-filter='overreactor'
          onClick={onClick}
        >
          <svg className='icon icon-close-alt'>
            <use xlinkHref='#icon-close-alt' />
          </svg>
          <strong>Overreactor</strong>
          <figure className='filter-items__icon'>
            <LazyImg src={explodingHead} alt='exploding-head' />
          </figure>
        </button>
      </div>
    </Sticky>
  );
};

export default ReviewsFilter;
